<template lang="pug">
  #filterSKUModal.d-flex.flex-column(:class="{ 'show': isOpened }" @click.stop)
    .header.flex-shrink-0.d-flex
      icon.align-self-center(icon="chevron-left" stroke="#1e1e20" :width="24" :height="24" v-show="level > 0" @click.native="back")
      h3.modal-title.font-weight-bold 篩選
      button.ml-auto(type="button" class="close" @click="toggleOpen")
        span(aria-hidden="true") &times;
    .body.mt-4
      template(v-if="level === 0")
        .filter.mb-4(v-for="filter in displayFilters" :key="filter.filter")
          .d-flex.justify-content-between.mb-2
            .title.font-weight-medium {{ $t(`__${filter.filter}`) }}
            .more.pointer-cursor(v-show="filter.options.length > 9" @click="seeMore(filter)")
              span 看更多
              icon.align-bottom(icon="chevron-right" stroke="#1e1e20")
          .options
            .option.pointer-cursor(
              v-for="option in filter.options.slice(0, 9)" :key="`option-${option}`"
              :class="{ 'selected': isOptionSelected(filter.filter, option) }"
              @click="select(filter.filter, option)"
            ) {{ $t(`__${option}`) }}
      template(v-else)
        .filter
          .title.font-weight-medium.mb-2 {{ $t(`__${selectedFilter.filter}`) }}
          .options
            .option.pointer-cursor(
              v-for="option in selectedFilter.options" :key="`option-${option}`"
                :class="{ 'selected': isOptionSelected(selectedFilter.filter, option) }"
                @click="select(selectedFilter.filter, option)"
              ) {{ $t(`__${option}`) }}
    .footer.position-absolute.bg-white.w-100
      button.btn.btn-block.text-light(type="button" @click="reset") 清空
</template>

<script>
import { SEX, RELATED_SPORTS, APPAREL_BRANDS, FOOD_BRANDS } from '@/global/filter';
import Icon from '@/components/Icon.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'FilterSKUModal',
  components: {
    Icon,
  },
  props: {
    selectedDepartment: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpened: false,
      level: 0,
      filterParams: {
        sexes: [],
        brands: [],
        relatedSports: [],
      },
      selectedFilter: null,
    };
  },
  computed: {
    ...mapState('sku', [
      'skus',
    ]),
    ...mapGetters('sku', [
      'commoditiesFilterParams',
    ]),
    displayFilters() {
      if (this.level === 0) {
        if (this.selectedDepartment === 'apparel') {
          return [
            {
              filter: 'sexes',
              options: [...this.filterParams.sexes, ...this.unselectedSexes],
            },
            {
              filter: 'brands',
              options: [...this.filterParams.brands, ...this.unselectedApparelBrands],
            },
            {
              filter: 'relatedSports',
              options: [...this.filterParams.relatedSports, ...this.unselectedRelatedSports],
            },
          ];
        }
        if (this.selectedDepartment === 'foods') {
          return [
            {
              filter: 'brands',
              options: [...this.filterParams.brands, ...this.unselectedFoodBrands],
            },
          ];
        }
      }
      return [];
    },
    unselectedSexes() {
      return SEX.filter((s) => !this.filterParams.sexes.includes(s));
    },
    unselectedApparelBrands() {
      return APPAREL_BRANDS.filter((b) => !this.filterParams.brands.includes(b));
    },
    unselectedRelatedSports() {
      return RELATED_SPORTS.filter((s) => !this.filterParams.relatedSports.includes(s));
    },
    unselectedFoodBrands() {
      return FOOD_BRANDS.filter((b) => !this.filterParams.brands.includes(b));
    },
  },
  methods: {
    toggleOpen() {
      this.isOpened = !this.isOpened;
      this.level = 0;
      if (this.isOpened) {
        this.filterParams.sexes = this.commoditiesFilterParams.sexes ? [...this.commoditiesFilterParams.sexes] : [];
        this.filterParams.brands = this.commoditiesFilterParams.brands ? [...this.commoditiesFilterParams.brands] : [];
        this.filterParams.relatedSports = this.commoditiesFilterParams.relatedSports ? [...this.commoditiesFilterParams.relatedSports] : [];
        $('#mobile-backdrop').addClass('show');
      } else {
        this.apply();
        $('#mobile-backdrop').removeClass('show');
      }
    },
    select(filter, option) {
      const i = this.filterParams[filter].findIndex((o) => o === option);
      if (i > -1) {
        this.filterParams[filter].splice(i, 1);
      } else {
        this.filterParams[filter].push(option);
      }
    },
    isOptionSelected(filter, option) {
      return this.filterParams[filter].some((o) => o === option);
    },
    seeMore(filter) {
      this.level += 1;
      this.selectedFilter = filter;
    },
    back() {
      this.level -= 1;
      this.selectedFilter = null;
    },
    reset() {
      this.filterParams.sexes = [];
      this.filterParams.brands = [];
      this.filterParams.relatedSports = [];
    },
    apply() {
      this.$emit('select', this.filterParams);
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/assets/styles/variables'

#filterSKUModal
  position: fixed !important
  top: 0
  right: -300px
  transition: all 0.3s
  z-index: 1050

  height: 100vh
  width: 300px
  padding: 20px
  background-color: #fff
  overflow-y: auto

  &.show
    transform: translateX(-300px)

  .filter

    .more
      color: #787879

    .options
      display: grid
      grid-template-columns: repeat(3, 1fr)
      gap: 10px

      .option
        background-color: $primary-100
        color: #787879
        text-align: center
        padding: 6px 0
        border-radius: 8px
        word-break: break-word

        &.selected
          background-color: $primary
          color: #fff

    .sub-filter
      font-size: 14px
      margin-top: 20px

  .body
    overflow-y: auto
    padding-bottom: 40px

  .footer
    left: 0
    bottom: 0
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1)
</style>
